import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Order from './index';
import MobileOrder from './MobileOrder';

const ResponsiveOrder = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileOrder />}
      desktop={<Order />}
    />
  );
};

export default ResponsiveOrder;